import { createElement } from 'rax';
import EmbedMinutePicker from '../embed-picker/minute-picker';
import BaseRangePicker from './base-range-picker';
import { withLocale } from '../../locale';
class MinuteRangePicker extends BaseRangePicker {
    get rangeType() {
        return 'minute';
    }
    get format() {
        return this.props.format || 'YYYY-MM-DD HH:mm';
    }
    renderFirstChild(value, validRange, onChange) {
        return <EmbedMinutePicker value={value} validRange={validRange} onChange={onChange}/>;
    }
    renderSecondChild(value, validRange, onChange) {
        return <EmbedMinutePicker value={value} validRange={validRange} onChange={onChange}/>;
    }
}
export default withLocale(MinuteRangePicker, {
    name: 'MinuteRangePicker',
    defaultLocale: {
        ok: '',
        cancel: '',
        prev: '上一步',
        next: '下一步',
        selectStartTime: '选择开始时间',
        selectEndTime: '选择结束时间',
    },
});
